export default [
  { key: 'topic_type', value: 'news', title: 'Новости' },
  { key: 'topic_type', value: 'article', title: 'Статьи' },
  { key: 'topic_type', value: 'gallery', title: 'Фото' },
  { key: 'topic_type', value: 'video', title: 'Видео' },
  { key: 'topic_type', value: 'quiz', title: 'Тесты' },
];
